import React from 'react';

import { Button } from '@sravni/react-design-system';

import { ORGANIZATION_LIST, ORGANIZATION_LIST_MFO, PRODUCT_LIST, PRODUCT_LIST_MFO } from '../../../../constants/routes';
import { checkIfMfo } from '../../../../helpers/reviews';
import { createLinkProps } from '../../../../utils/routing';
import { IMainSelectProps, TSelectValue } from '../MainSelect';

interface IMainSelectButtonProps extends Pick<IMainSelectProps, 'reviewTypes' | 'type' | 'isMobile'> {
  organizationValue: TSelectValue;
  serviceValue: TSelectValue;
}

export const MainSelectButton: React.FC<IMainSelectButtonProps> = ({
  type,
  reviewTypes,
  organizationValue,
  serviceValue,
  isMobile,
}) => {
  const isMfo = checkIfMfo(type);

  const currentService = serviceValue?.alias;
  const mfoPattern = currentService ? PRODUCT_LIST_MFO : ORGANIZATION_LIST_MFO;
  const commonPattern = currentService ? PRODUCT_LIST : ORGANIZATION_LIST;

  const buttonLink = createLinkProps('/list', isMfo ? mfoPattern : commonPattern, {
    type: reviewTypes.itemTypeUrl,
    organization: organizationValue?.alias,
    ...(currentService && { product: currentService }),
  });

  const disabled = !organizationValue?.value && !serviceValue?.value;

  const button = (
    <Button variant={isMobile ? 'outlined' : 'primary'} size={isMobile ? 44 : 60} disabled={disabled} block={isMobile}>
      Показать
    </Button>
  );

  if (disabled) return button;

  return <a href={buttonLink.as}>{button}</a>;
};
